
import { getReplenishmentGeneralReport } from '../api/getReplenishmentReport';
import { setGetReplenishmentReportAction } from '../action';

export const setGetReplenishmentGeneralReport = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getReplenishmentGeneralReport(params);
            console.log(data)
            dispatch(setGetReplenishmentReportAction({
                list: data.list,
                totalPage: data.totalPage
            }));
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}